import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const X = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="X" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.929 5.343L10.586 12l-6.657 6.657 1.414 1.414L12 13.414l6.657 6.657 1.414-1.414L13.414 12l6.657-6.657-1.414-1.414L12 10.586 5.343 3.929 3.929 5.343z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
